import React from 'react';
import { cx } from './utils';

export default function Spinner({ className, label = 'Laden…' }) {
  return (
    <div className={cx('spinner', className)} role="status" aria-live="polite">
      <div className="spinner__dot" aria-hidden="true" />
      <span className="spinner__label">{label}</span>
    </div>
  );
}
